module.exports = __webpack_public_path__ + "site/img/p2.933f11b3.png";